var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, Defaults, P, PCSS, ViewChild, Watch, PropertyConverters, Utils, Components } from '@pacem/pacem-core';
import { Components as UIComponents } from '@pacem/pacem-ui';
const UI = UIComponents.UI;
function getGallerySlideShowTemplate(captionTemplate = getDefaultCaptionTemplate(), imageProperty = 'image') {
    return `<${P}-slide class="${PCSS}-gallery-item"
css-class="{{ { '${PCSS}-gallery-previous': :host.isPrevious(^index, ::_slideshow.index), '${PCSS}-gallery-next': :host.isNext(^index, ::_slideshow.index), '${PCSS}-gallery-focus': ^index === ::_slideshow.index } }}"
>
            <${P}-img src="{{ ^item.${imageProperty} }}" disabled="{{ !::_lightbox.show || !(:host.isCloseTo(^index, ::_slideshow.index) || ^index === ::_slideshow.index) }}"
css="{{ {'visibility': (:host._poppingUp ? 'hidden' : ''), 'transition': (:host._poppingUp ? 'none' : '')} }}" class="${PCSS}-gallery-splash" adapt="contain"></${P}-img>

${captionTemplate}

            </${P}-slide>`;
}
function getDefaultCaptionTemplate(captionProperty = 'caption') {
    return `<${P}-panel hide="{{ $pacem.isNullOrEmpty(^item.${captionProperty}) }}" class="${PCSS}-gallery-caption gallery-caption-default">
        <${P}-span class="paragraph" text="{{ ^item.${captionProperty} }}"></${P}-span>
    </${P}-panel>`;
}
;
let PacemGalleryElement = class PacemGalleryElement extends UI.PacemAdaptedIterativeElement {
    constructor() {
        super(...arguments);
        this._templateChangeHandler = (evt) => {
            const proxy = evt.target;
            this._setupWithCaptionTemplate(proxy.target);
        };
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._setupWithCaptionTemplate();
        this._databind();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first) {
            switch (name) {
                case 'datasource':
                    this._databind();
                    break;
                case 'captionTemplate':
                    this._setupWithCaptionTemplate(val, old);
                    break;
                case 'imageProperty':
                    this._setupWithCaptionTemplate(this.captionTemplate, this.captionTemplate);
                    break;
                case 'captionProperty':
                    if (Utils.isNull(this.captionTemplate)) {
                        this._setupDefaultTemplate();
                    }
                    break;
            }
        }
    }
    disconnectedCallback() {
        this._disposeTemplate();
        super.disconnectedCallback();
    }
    _disposeTemplate(val = this.captionTemplate) {
        if (val instanceof Components.PacemTemplateProxyElement) {
            val.removeEventListener('templatechange', this._templateChangeHandler);
        }
    }
    _setupWithCaptionTemplate(val = this.captionTemplate, old) {
        this._disposeTemplate(old);
        if (Utils.isNull(val)) {
            this._setupDefaultTemplate();
            return;
        }
        if (val instanceof Components.PacemTemplateProxyElement) {
            val.addEventListener('templatechange', this._templateChangeHandler, false);
            val = val.target;
        }
        const container = val.content.firstElementChild;
        Utils.addClass(container, PCSS + '-gallery-caption');
        const tmpl = document.createElement('template');
        tmpl.innerHTML = getGallerySlideShowTemplate(val.innerHTML, this.imageProperty);
        this._setupTemplate(tmpl);
    }
    _setupTemplate(val) {
        this._templateProxy.target = val;
    }
    _setupDefaultTemplate() {
        const tmpl = document.createElement('template');
        tmpl.innerHTML = getGallerySlideShowTemplate(getDefaultCaptionTemplate(this.captionProperty), this.imageProperty);
        this._setupTemplate(tmpl);
    }
    _databind() {
        const rep = this._repeater;
        if (!Utils.isNull(rep)) {
            rep.datasource = this.datasource;
        }
    }
    get adapter() {
        return this._adapter;
    }
    async _heroAnimate(fromEl, src) {
        if (!Utils.isNull(fromEl)) {
            let pImg = new UI.PacemImageElement();
            let goalEl = this._heroPlaceholderProxy.dom[0];
            const TRANSITION = 300;
            pImg.src = src || /* assuming an img-ish element */ fromEl['src'];
            pImg.adapt = 'contain';
            let goal = Utils.offset(goalEl), from = Utils.offset(fromEl), style = pImg.style;
            const cfrStyle = getComputedStyle(goalEl);
            style.border = cfrStyle.border;
            style.width = goalEl.clientWidth + 'px';
            style.height = goalEl.clientHeight + 'px';
            style.position = 'absolute';
            style.zIndex = cfrStyle.zIndex;
            style.top = goal.top + 'px';
            style.left = goal.left + 'px';
            const scaleX = fromEl.clientWidth / goalEl.clientWidth, scaleY = fromEl.clientHeight / goalEl.clientHeight, translateX = (from.left - goal.left) + 'px', translateY = (from.top - goal.top) + 'px';
            style.transformOrigin = '0 0';
            style.transition = `transform cubic-bezier(0.445, 0.05, 0.55, 0.95) ${TRANSITION}ms, opacity ${TRANSITION}ms`;
            style.transform = `translate(${translateX}, ${translateY}) scale(${scaleX}, ${scaleY})`;
            document.body.appendChild(pImg);
            requestAnimationFrame(() => {
                pImg.style.transform = '';
            });
            await Utils.waitForAnimationEnd(pImg, TRANSITION);
            pImg.remove();
        }
    }
    open(startIndex, heroFrom, src) {
        this._poppingUp = true;
        this._lightbox.show = true;
        this._slideshow.index = startIndex; // reflects on 'this' (twoway)
        this._heroAnimate(heroFrom, src)
            .then(_ => {
            this._poppingUp = false;
            this._slideshow.focus();
        });
    }
};
__decorate([
    ViewChild(P + '-adapter')
], PacemGalleryElement.prototype, "_adapter", void 0);
__decorate([
    ViewChild(P + '-lightbox')
], PacemGalleryElement.prototype, "_lightbox", void 0);
__decorate([
    ViewChild(P + '-slideshow')
], PacemGalleryElement.prototype, "_slideshow", void 0);
__decorate([
    ViewChild(P + '-repeater')
], PacemGalleryElement.prototype, "_repeater", void 0);
__decorate([
    ViewChild(P + '-template-proxy')
], PacemGalleryElement.prototype, "_templateProxy", void 0);
__decorate([
    ViewChild(P + '-shell-proxy')
], PacemGalleryElement.prototype, "_heroPlaceholderProxy", void 0);
__decorate([
    Watch()
], PacemGalleryElement.prototype, "_poppingUp", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Element })
], PacemGalleryElement.prototype, "captionTemplate", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemGalleryElement.prototype, "captionProperty", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemGalleryElement.prototype, "imageProperty", void 0);
PacemGalleryElement = __decorate([
    CustomElement({
        tagName: P + '-gallery', shadow: Defaults.USE_SHADOW_ROOT,
        template: `<${P}-lightbox class="${PCSS}-gallery">
    <${P}-repeater>
        <${P}-slideshow adapter="{{ ::_adapter }}" index="{{ :host.index, twoway }}" hide="{{ !::_lightbox.show }}">
            <${P}-template-proxy></${P}-template-proxy>
        </${P}-slideshow>
    </${P}-repeater>
<${P}-adapter class="${PCSS}-gallery-adapter"></${P}-adapter>
</${P}-lightbox>
<${P}-shell-proxy><div class="${PCSS}-gallery-hero-target"></div></${P}-shell-proxy>`
    })
], PacemGalleryElement);
export { PacemGalleryElement };
